export class CasemanService {
  constructor ($q, API, Auth) {
    'ngInject';

    this.$q = $q;
    this.API = API;
    this.Auth = Auth;
   }

  // Config Teams
  getSitesKlix() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/country/sites'
    });
  }

  getSitesCASEMAN() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/caseman-sites'
    });
  }

  getTeamsKlixBySite(siteId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/sites/'+ siteId +'/teams'
    });
  }

  getTeamsCASEMANbySite(siteId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/caseman-sites/'+ siteId +'/teams'
    });
  }

  getAllTeamsCASEMAN() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/caseman-teams'
    });
  }

  getTeamsMapperBySite(siteId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/sites/' + siteId + '/team-mappers'
    });
  }

  setTeams(teamId,casemanTeamId) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/team-mappers',
      data: {teamId, casemanTeamId}
    });
  }

  deleteTeamMapper(teamId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root  +  '/team-mappers/' + teamId
    });
  }

  //Config Teams - TL
  getTeamMapper() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/team/team-mapper'
    });
  }

  // Config Users - LA
  getUsersByCountryKlix() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/users'
    });
  }

  getUsersByCountryCASEMAN() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/country/caseman-users'
    });
  }

  getUsersMapperByCountry() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/user-mappers'
    });
  }

  //Config Users - TL
  getUsersByTeamKlix() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/team/users'
    });
  }

  getUsersByTeamCASEMAN() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/team/caseman-users'
    });
  }

  getUsersMapperByTeam() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/team/user-mappers'
    });
  }

  //Config Users LA and TL
  setUserMapper(userId, casemanUserId) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/user-mappers',
      data: {userId, casemanUserId}
    });
  }

  deleteUserMapper(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/user-mappers/' + userId
    });
  }

  // Config Clients LA
  getCountryClients() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/clients'
    });
  }

  getCountryClientMappers() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/client-project-mappers'
    });
  }

  getCountryCasemanClients() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/caseman-clients'
    });
  }

  setClientClientMapper(clientId, casemanClientId) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/client-mappers',
      data: {clientId, casemanClientId}
    });
  }

  deleteClientClientMapper(clientId, casemanClientId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/client-mappers',
      data: {clientId, casemanClientId}
    });
  }

  getCountryCasemanProjects() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/caseman-projects'
    });
  }

  getTeamCasemanClients() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/team/caseman-clients'
    });
  }

  // Config Clients TL
  getTeamClients() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/team/clients'
    });
  }

  getTeamClientMappers() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/team/client-project-mappers'
    });
  }

  getTeamCasemanProjects() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/team/caseman-projects'
    });
  }

  //Config Clients LA and TL
  setClientMapper(clientId, casemanProjectId, casemanCountryCode) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/client-project-mappers',
      data: {clientId, casemanProjectId, casemanCountryCode}
    });
  }

  deleteClientMapper(clientMapperId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/client-project-mappers/' + clientMapperId
    });
  }

  //Config Process Groups LA and TL
  getCountryProcessGroups() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/process-groups'
    });
  }

  getCountryProcesses() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/processes'
    });
  }

  getCountryProcessExceptionMappers() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/process-exception-mappers'
    });
  }

  getCountryInterrupts() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/interrupts'
    });
  }

  getCountryProcessGroupsMappers() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/process-group-mappers'
    });
  }

  //Config Process Groups LA
  getCountryCasemanJobcodesAndSubcodes() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/caseman-job-codes'
    });
  }

  setCountryProcessGroupMapper(interruptCountryConfigurationId, processGroupCountryConfigurationId, jobCodeId, country) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root +  '/process-group-mappers',
      data: {interruptCountryConfigurationId, processGroupCountryConfigurationId, jobCodeId, country}
    });
  }

  editCountryProcessGroupMapper(id, interruptCountryConfigurationId, processGroupCountryConfigurationId, jobCodeId, country) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root +  '/process-group-mappers/' + id,
      data: {interruptCountryConfigurationId, processGroupCountryConfigurationId, jobCodeId, country}
    });
  }

  deleteCountryProcessGroupMapper(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root  +  '/process-group-mappers/' + id
    });
  }

  // Processes Config
  getPgProcesses(processGroupId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/process-groups/' + processGroupId + '/processes'
    });
  }

  getCasemanSubcodes(country, subcodeId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/caseman-countries/' + country + '/caseman-job-codes/' + subcodeId + '/sub-codes'
    });
  }

  getPgProcessesMappers(processGroupId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/process-groups/' + processGroupId + '/process-mappers'
    });
  }

  setPgProcessMapper(processId, subCodeId) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root +  '/process-mappers',
      data: {processId, subCodeId}
    });
  }

  deletePgProcessMapper(pMapperId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root  +  '/process-mappers/' + pMapperId
    });
  }

  // Matching
  getUserClients(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/users/' + userId + '/clients'
    });
  }

  getUserClientsLegacy(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/users/' + userId + '/clients-legacy'
    });
  }

  getTeams() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/teams'
    });
  }

  getIncomeMappers(teamId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/income-mappers/team/' + teamId
    });
  }

  setIncomeMappers(teamId, arrayOfMappers) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/income-mappers/team/' + teamId,
      data: arrayOfMappers
    });
  }

  getProcessesByClient(clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/clients/' + clientId + '/worklogs'
    });
  }

  getProcessMappers() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/worklog-mappers'
    });
  }

  getProcessMappersByClient(userId, clientId, projectId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/users/' + userId + '/clients/'+ clientId + '/worklog-mappers/' + projectId
    });
  }

  getProcessMappersByClientOld(userId, clientId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/users/' + userId + '/clients/'+ clientId + '/worklog-mappers'
    });
  }

  getTeamProcessMappersByProjectId(teamId, clientId, projectId) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/teams/${teamId}/clients/${clientId}/worklog-team-mappers/${projectId}`
    });
  }

  getCasemanProjects() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/user/caseman-projects'
    });
  }

  getUserCasemanProjects(userId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/users/' + userId + '/caseman-projects'
    });
  }

  getCasemanProjectsByTeamId(teamId) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/teams/${teamId}/caseman-projects`
    });
  }


  getCasemanJobcodes(country, casemanProjectId) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root  + '/caseman-countries/' + country + '/caseman-project/' + casemanProjectId + '/jobCodes'
    });
  }

  setProcessMatch(params) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/worklog-mappers',
      data: params
    });
  }

  setProcessMatchForTeam(params) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/worklog-team-mappers',
      data: params
    });
  }

  editProcessMatch(params){
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/worklog-mappers/' + params.id,
      data: params
    });
  }

  editProcessMatchForTeam(params) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/worklog-team-mappers/' + params.id,
      data: params
    });
  }

  deleteProcessMatch(processId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/worklog-mappers/' + processId
    });
  }

  deleteProcessMatchForTeam(processId) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/worklog-team-mappers/' + processId
    });
  }

  // Synchronization
  getAggregates(from, to) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/caseman-packages',
      params: {
        from,
        to
      }
    });
  }

  sendAggregates(requests) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/caseman-tasks',
      data: {requests}
    });
  }

  getUserSyncSettings() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/user-mapper'
    });
  }

  updateUserSyncSettings(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/user-mapper',
      data: data
    });
  }

  getWorklogsForAggregate(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/worklog',
      params: { id, includeArchived: true }
    });
  }

  saveException(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/process-exception-mappers',
      data: data
    });
  }

  deleteException(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/process-exception-mappers/${id}`
    });
  }

  getIntegrationStrategy() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/country/settings'
    });
  }

  saveIntegrationStrategy(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/country/settings',
      data: data
    });
  }

  // e.g. params: {from: 2022-07-01, to: 2022-07-02}
  getExportSyncProblemsExcel(params) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/caseman/sync/report',
      params: params,
      responseType: 'blob'
    });
  }

  getClientsByTeamId(teamId) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/teams/${teamId}/clients`
    });
  }

  getProcessMappersByTeamId(teamId, clientId) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + `/teams/${teamId}/clients/${clientId}/worklog-team-mappers`
    });
  }
}
